import { addDays, differenceInDays } from 'date-fns';
import { invariant } from '@vp/digital-invariant-lib';
import { RetryPolicy, GraphqlClientDispenser, HttpClientDispenser } from '@vp/digital-http-client-lib';
import { getLibraryLoggingAttributes, getLogger, Dispenser } from '@vp/digital-logging-lib';
import { getClientEnvironment, Environment } from '@vp/digital-environment-lib';
import axios from 'axios';
import { getPartnerIntegrationOrigin } from '@vp/digital-url-service-lib';
import { getIdentity, useIdentity } from '@vp/digital-auth-lib';
import { orderTypeEnum, processOrder } from '@vp/digital-cart-lib';
import React, { useEffect } from 'react';
import { useLocale } from '@vp/digital-locale-lib';

var customerLeadTypeEnum;
(function (customerLeadTypeEnum) {
    customerLeadTypeEnum["None"] = "none";
    customerLeadTypeEnum["CurrentPurchaser"] = "currentPurchaser";
    customerLeadTypeEnum["PreviousDiwyPurchaser"] = "previousDiwyPurchaser";
    customerLeadTypeEnum["Trialer"] = "trialer";
    customerLeadTypeEnum["ExpiredTrialer"] = "expiredTrialer";
    customerLeadTypeEnum["PreviousPurchaserUnpublished"] = "previousPurchaserUnpublished";
    customerLeadTypeEnum["MatchingLead"] = "matchingLead";
    customerLeadTypeEnum["MatchingWixFreemiumLead"] = "matchingWixFreemiumLead";
    customerLeadTypeEnum["MatchingWixSinglePremiumLead"] = "matchingWixSinglePremiumLead";
    customerLeadTypeEnum["MatchingWixMultiplePremiumLead"] = "matchingWixMultiplePremiumLead";
    customerLeadTypeEnum["NonMatchingLead"] = "nonMatchingLead";
    customerLeadTypeEnum["NonMatchingWixLead"] = "nonMatchingWixLead";
    customerLeadTypeEnum["WixSinglePremiumWithDomainSearchVoucher"] = "wixSinglePremiumWithDomainSearchVoucher";
    customerLeadTypeEnum["WixSinglePremiumWithDomainSearchWithoutVoucher"] = "wixSinglePremiumWithDomainSearchWithoutVoucher";
    customerLeadTypeEnum["WixNewUserDomainsPurchase"] = "wixNewUserDomainsPurchase";
    customerLeadTypeEnum["WixExistingPremiumSiteUserDomainPurchase"] = "wixExistingPremiumSiteUserDomainPurchase";
    customerLeadTypeEnum["WixFreeUserSiteUpgradeThroughDomains"] = "wixFreeUserSiteUpgradeThroughDomains";
    customerLeadTypeEnum["WixFreeUserWithOwnDomainSiteUpgradeThroughDomains"] = "wixFreeUserWithOwnDomainSiteUpgradeThroughDomains";
    customerLeadTypeEnum["WixSinglePremiumMonthly"] = "wixSinglePremiumMonthly";
})(customerLeadTypeEnum || (customerLeadTypeEnum = {}));

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var SUBSCRIPTION_LENGTH_DAYS = 30;
function getDaysLeft(createdAt, nowAt) {
    var createdAtDate = new Date(createdAt);
    var expirationDate = addDays(createdAtDate, SUBSCRIPTION_LENGTH_DAYS);
    var daysLeftTrial = nowAt > expirationDate.valueOf()
        ? 0
        : differenceInDays(expirationDate, nowAt);
    var daysSincePurchase = differenceInDays(nowAt, createdAtDate);
    return [daysLeftTrial, daysSincePurchase];
}

var TOWER_TYPE = 'TOWER';
function findTowerAccount(accountGroup) {
    for (var _i = 0, _a = accountGroup.accounts; _i < _a.length; _i++) {
        var account = _a[_i];
        if (account.benefit.benefitType === TOWER_TYPE) {
            return account;
        }
    }
}

var ACTIVE_ACCOUNT = 'ACTIVE';
function findCurrentTowerAccountGroup(accountGroups) {
    if (!accountGroups) {
        return null;
    }
    accountGroups.sort(function (ag1, ag2) {
        return ag2.createdDate.localeCompare(ag1.createdDate);
    });
    var towerAccountGroup = accountGroups.find(function (accountGroup) {
        return accountGroup.accounts.find(function (account) {
            return account.accountType === TOWER_TYPE &&
                account.status === ACTIVE_ACCOUNT;
        });
    });
    return towerAccountGroup;
}

function getTrialType(daysLeftTrial, daysSincePurchase) {
    if (daysLeftTrial > 0) {
        return customerLeadTypeEnum.Trialer;
    }
    else if (daysSincePurchase < 90) {
        return customerLeadTypeEnum.ExpiredTrialer;
    }
    return customerLeadTypeEnum.ExpiredTrialer;
}

var name = "@vp/digital-paid-lib";
var version = "0.19.21";

var getLibLogger = function (attributes) {
    var attr = getLibraryLoggingAttributes(name, version, attributes);
    return getLogger(attr);
};

var getDefaultConfig = function (config) { return ({
    paidApi: {
        baseUrl: config.paidApiOrigin,
        operations: {
            getAccountGroups: {
                timeoutMS: 5 * 1000,
                cache: {
                    maxAgeMS: 60 * 1000,
                    maxSize: 10,
                },
                retry: {
                    policy: RetryPolicy.LinearBackOff,
                    count: 1,
                },
            },
        },
    },
    accountServiceApi: {
        baseUrl: config.accountServiceOrigin,
        operations: {
            createFreeAccountGroup: {
                timeoutMS: 10 * 1000,
                cache: {
                    maxAgeMS: 60 * 1000,
                    maxSize: 10,
                },
                retry: {
                    policy: RetryPolicy.LinearBackOff,
                    count: 1,
                },
            },
            getSubscriptionGroupAltId: {
                timeoutMS: 10 * 1000,
                cache: {
                    maxAgeMS: 60 * 1000,
                    maxSize: 10,
                },
                retry: {
                    policy: RetryPolicy.LinearBackOff,
                    count: 1,
                },
            },
        },
    },
    partnerServiceApi: {
        baseUrl: config.partnerServiceApiOrigin,
        operations: {
            getPartnerStandardCardAccount: {
                timeoutMS: 5 * 1000,
                cache: {
                    maxAgeMS: 60 * 1000,
                    maxSize: 10,
                },
                retry: {
                    policy: RetryPolicy.LinearBackOff,
                    count: 1,
                },
            },
            getPartnerDomainSearchData: {
                timeoutMS: 5 * 1000,
                cache: {
                    maxAgeMS: 60 * 1000,
                    maxSize: 10,
                },
                retry: {
                    policy: RetryPolicy.LinearBackOff,
                    count: 1,
                },
            },
            getPartnerAccountDomainSearchData: {
                timeoutMS: 10 * 1000,
                cache: {
                    maxAgeMS: 60 * 1000,
                    maxSize: 10,
                },
                retry: {
                    policy: RetryPolicy.LinearBackOff,
                    count: 1,
                },
            },
            getPartnerOrderConfirmationData: {
                timeoutMS: 5 * 1000,
                cache: {
                    maxAgeMS: 60 * 1000,
                    maxSize: 10,
                },
                retry: {
                    policy: RetryPolicy.LinearBackOff,
                    count: 1,
                },
            },
            getPartnerDomainRegistrantId: {
                timeoutMS: 10 * 1000,
                cache: {
                    maxAgeMS: 60 * 1000,
                    maxSize: 10,
                },
                retry: {
                    policy: RetryPolicy.LinearBackOff,
                    count: 1,
                },
            },
        },
    },
    subscriptionsServiceApi: {
        baseUrl: config.subscriptionsServiceApiOrigin,
        operations: {
            getCurrentPlanInfo: {
                timeoutMS: 5 * 1000,
                cache: {
                    maxAgeMS: 60 * 1000,
                    maxSize: 10,
                },
                retry: {
                    policy: RetryPolicy.LinearBackOff,
                    count: 1,
                },
            },
            scheduledChange: {
                timeoutMS: 5 * 1000,
                cache: {
                    maxAgeMS: 60 * 1000,
                    maxSize: 10,
                },
                retry: {
                    policy: RetryPolicy.LinearBackOff,
                    count: 1,
                },
            },
        },
    },
}); };

var prodConfig = {
    accountServiceOrigin: 'https://account-service.orders.vpsvc.com',
    paidApiOrigin: 'https://subscription-data-api.orders.vpsvc.com',
    partnerServiceApiOrigin: 'https://partners.vpsvc.com',
    subscriptionsServiceApiOrigin: getSubscriptionOrigin(),
};
var stagingConfig = {
    accountServiceOrigin: 'https://account-service-staging.orders.vpsvc.com',
    paidApiOrigin: 'https://subscription-data-api-staging.orders.vpsvc.com',
    partnerServiceApiOrigin: 'https://qa.partner-integration.digital.vpsvc.com',
    subscriptionsServiceApiOrigin: getSubscriptionOrigin(false),
};
var localConfig = {
    accountServiceOrigin: 'https://account-service-staging.orders.vpsvc.com',
    paidApiOrigin: 'https://subscription-data-api-staging.orders.vpsvc.com',
    partnerServiceApiOrigin: 'https://qa.partner-integration.digital.vpsvc.com',
    subscriptionsServiceApiOrigin: getSubscriptionOrigin(false),
};
function getSubscriptionOrigin(isProd) {
    if (isProd === void 0) { isProd = true; }
    if (!isProd) {
        return 'https://subscription-service-staging.orders.vpsvc.com';
    }
    return 'https://subscription-service.orders.vpsvc.com';
}

function getClientConfig() {
    var env = getClientEnvironment();
    switch (env) {
        case Environment.Prod:
            return prodConfig;
        case Environment.Staging:
            return stagingConfig;
        case Environment.Local:
            return localConfig;
    }
    throw new Error('Cannot determine which environment to use');
}

function getAccountGroupsQuery(shopperId, country) {
    return {
        query: "{\n      accountGroups: accountGroupsByShopperId(\n        shopperId: \"".concat(shopperId, "\"\n        country: \"").concat(country, "\"\n        excludeMonolithAccountGroups: false\n      ) {\n        ... on AccountGroup {\n          source\n          altId\n        }\n        ... on MonolithMappedAccountGroup {\n          source\n        }\n      }\n    }"),
    };
}

function getAccountGroupsWithMetadataQuery(shopperId, country) {
    return {
        query: "{\n      accountGroups: accountGroupsByShopperId(\n        shopperId: \"".concat(shopperId, "\"\n        country: \"").concat(country, "\"\n        excludeMonolithAccountGroups: true\n      ) {\n        ... on AccountGroup {\n          source,\n          altId,\n          createdDate,\n          packageAltId,\n          isTrial\n          accounts {\n            altId,\n            accountType,\n            status,\n            benefitAltId,\n            subscription {\n              productId\n            },\n            benefit {\n              ... on Benefit {\n              altId,\n              createdDate,\n              digitalUserId,\n              benefitGroupAltId,\n              benefitType,\n              locale,\n              status,\n              modifierFlags,\n              properties,\n              entitlements,\n              externalId,\n              external {\n                  ... on TowerSite {\n                      siteId,\n                      createdAt,\n                      updatedAt,\n                      shopperId,\n                      benefitId,\n                      legacy,\n                      version,\n                      editVersion,\n                      firstPublishedAt,\n                      lastPublishedAt,\n                      domain,\n                      domains,\n                      isFrozen,\n                      isCancelled,\n                      isUnpublished\n                      sitePreviewUrl,\n                      templatePreviewUrl,\n                      }\n                  }\n              }\n            }\n          }\n        }\n      }\n  }"),
    };
}

var config$c = getClientConfig();
var apiConfig$c = getDefaultConfig(config$c).paidApi;
var opConfig$c = apiConfig$c.operations.getAccountGroups;
var ddapiClientDispenser$1 = new GraphqlClientDispenser(apiConfig$c, opConfig$c, true);
function getAccountGroups(shopperId, country, includeMetadata) {
    return __awaiter(this, void 0, void 0, function () {
        var query, axiosConfig, accountGroups;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    invariant(shopperId, 'Required parameter is missing: shopperId');
                    invariant(country, 'Required parameter is missing: country');
                    query = getAccountGroupsWithMetadataQuery(shopperId, country)
                        ;
                    axiosConfig = {
                        url: '/api/v1',
                        data: query,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, ddapiClientDispenser$1
                            .getInstance()
                            .request(axiosConfig)];
                case 2:
                    accountGroups = (_a.sent()).data;
                    return [2, accountGroups];
                case 3:
                    _a.sent();
                    getLibLogger().warn('getAccountGroups: Request to get accountGroups failed', { shopperId: shopperId });
                    return [2, { accountGroups: [] }];
                case 4: return [2];
            }
        });
    });
}

var config$b = getClientConfig();
var apiConfig$b = getDefaultConfig(config$b).partnerServiceApi;
var opConfig$b = apiConfig$b.operations.getPartnerStandardCardAccount;
new HttpClientDispenser(apiConfig$b, opConfig$b, true);
function getPartnerAccountGroup(shopperId, locale) {
    return __awaiter(this, void 0, void 0, function () {
        var accessToken, pathAndQueryString, PARTNER_ORIGIN, partnerStandardCardAccount;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    invariant(shopperId, 'Required parameter is missing: shopperId');
                    invariant(locale, 'Required parameter is missing: locale');
                    accessToken = getIdentity().accessToken;
                    pathAndQueryString = "api/v1/project/card/workspace/WIX/".concat(shopperId, "/").concat(locale);
                    PARTNER_ORIGIN = getPartnerIntegrationOrigin();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, axios.get("".concat(PARTNER_ORIGIN, "/").concat(pathAndQueryString), {
                            headers: {
                                'Content-Type': 'application/json',
                                authorization: "Bearer ".concat(accessToken),
                            },
                        })];
                case 2:
                    partnerStandardCardAccount = (_a.sent()).data;
                    return [2, partnerStandardCardAccount];
                case 3:
                    _a.sent();
                    getLibLogger().warn('getPartnerAccountGroups: Request to get partnerAccountGroups failed', { shopperId: shopperId });
                    return [2, null];
                case 4: return [2];
            }
        });
    });
}

function getPartnerOrderDataWithSiteId(shopperId, locale, siteIdsList) {
    return __awaiter(this, void 0, void 0, function () {
        var accessToken, pathAndQueryString, PARTNER_ORIGIN, partnerOrderData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    invariant(shopperId, 'Required parameter is missing: shopperId');
                    invariant(locale, 'Required parameter is missing: locale');
                    invariant(siteIdsList, 'Required parameter is missing: siteIds');
                    accessToken = getIdentity().accessToken;
                    pathAndQueryString = "api/v1/project/card/orderConfirmation/WIX/".concat(shopperId, "/").concat(locale);
                    PARTNER_ORIGIN = getPartnerIntegrationOrigin();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, axios.get("".concat(PARTNER_ORIGIN, "/").concat(pathAndQueryString), {
                            headers: {
                                'Content-Type': 'application/json',
                                authorization: "Bearer ".concat(accessToken),
                                siteId: siteIdsList,
                            },
                        })];
                case 2:
                    partnerOrderData = (_a.sent()).data;
                    return [2, partnerOrderData];
                case 3:
                    _a.sent();
                    getLibLogger().warn('getPartnerOrderDataWithSiteId: Request to get getPartnerOrderDataWithSiteId failed', { shopperId: shopperId });
                    return [2, null];
                case 4: return [2];
            }
        });
    });
}

function getPartnerAccountProducts(shopperId) {
    return __awaiter(this, void 0, void 0, function () {
        var logger, accessToken, pathAndQueryString, PARTNER_ORIGIN, partnerStandardCardAccount, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    invariant(shopperId, 'Required parameter is missing: shopperId');
                    logger = getLibLogger();
                    accessToken = getIdentity().accessToken;
                    pathAndQueryString = "api/v1/products/".concat(shopperId);
                    PARTNER_ORIGIN = getPartnerIntegrationOrigin();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    logger.info('getPartnerAccountProducts: calling with parameters ', {
                        shopperId: shopperId,
                    });
                    return [4, axios.get("".concat(PARTNER_ORIGIN, "/").concat(pathAndQueryString), {
                            headers: {
                                'Content-Type': 'application/json',
                                authorization: "Bearer ".concat(accessToken),
                            },
                        })];
                case 2:
                    partnerStandardCardAccount = (_a.sent()).data;
                    return [2, partnerStandardCardAccount];
                case 3:
                    e_1 = _a.sent();
                    logger.error('getPartnerAccountProducts: Request to get getPartnerAccountProducts failed', { shopperId: shopperId, e: e_1 });
                    return [2, null];
                case 4: return [2];
            }
        });
    });
}

var NO_TRIAL_DAYS = -1;
var isProduction = process.env.NODE_ENV === 'production';
var CONNECT_DOMAINS_PKG_ALT_ID = '761d6fe5-c3c9-41f8-887e-e436de501fd0';
var handleApiError = function (error, message) {
    console.error(message, error);
    if (isProduction) {
        throw new Error(message);
    }
    return null;
};
var fetchAccountAndPartnerData = function (shopperId, locale, country) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, accountGroupData, partnerAccountData, err_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4, Promise.all([
                        getAccountGroups(shopperId, country),
                        getPartnerAccountGroup(shopperId, locale),
                    ])];
            case 1:
                _a = _b.sent(), accountGroupData = _a[0], partnerAccountData = _a[1];
                return [2, { accountGroupData: accountGroupData, partnerAccountData: partnerAccountData }];
            case 2:
                err_1 = _b.sent();
                return [2, handleApiError(err_1, 'Failed to fetch account or partner data')];
            case 3: return [2];
        }
    });
}); };
function getCustomerLeadData(shopperId, locale, isWixLaunched, sitesIds, wixDomains, wixPlusSiteIds) {
    var _a, _b, _c, _d, _e;
    if (isWixLaunched === void 0) { isWixLaunched = false; }
    return __awaiter(this, void 0, void 0, function () {
        var country, partnerOrderData, _f, accountGroupData, partnerAccountData, towerAccountGroup, customerProductDetails, existingPremiumSiteUser, newUserDomainData, numberOfSitesOrdered, towerAccount, towerSite, _g, daysLeftTrial, daysSincePurchase, custType;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    country = locale.length > 2 ? locale.substring(3, 4) : locale;
                    if (wixPlusSiteIds && wixPlusSiteIds.length > 0) {
                        return [2, [customerLeadTypeEnum.PreviousDiwyPurchaser, NO_TRIAL_DAYS, {}]];
                    }
                    return [4, fetchAccountAndPartnerData(shopperId, locale, country)];
                case 1:
                    _f = _h.sent(), accountGroupData = _f.accountGroupData, partnerAccountData = _f.partnerAccountData;
                    if (!accountGroupData) {
                        return [2, [customerLeadTypeEnum.NonMatchingLead, NO_TRIAL_DAYS, {}]];
                    }
                    towerAccountGroup = findCurrentTowerAccountGroup(accountGroupData.accountGroups);
                    if (!isWixLaunched) return [3, 6];
                    if (!partnerAccountData) {
                        return [2, towerAccountGroup
                                ? null
                                : [customerLeadTypeEnum.NonMatchingWixLead, NO_TRIAL_DAYS, {}]];
                    }
                    if (!(sitesIds && sitesIds.length > 0)) return [3, 3];
                    return [4, getPartnerOrderDataWithSiteId(shopperId, locale, sitesIds).catch(function (err) {
                            var msg = "getPartnerOrderDataWithSiteId: Request to get partner data failed ".concat(err);
                            return handleApiError(err, msg);
                        })];
                case 2:
                    partnerOrderData = _h.sent();
                    _h.label = 3;
                case 3:
                    if (!(!sitesIds && wixDomains && wixDomains.length > 0)) return [3, 5];
                    return [4, getPartnerAccountProducts(shopperId)];
                case 4:
                    customerProductDetails = _h.sent();
                    existingPremiumSiteUser = (_a = customerProductDetails === null || customerProductDetails === void 0 ? void 0 : customerProductDetails.wixSites) === null || _a === void 0 ? void 0 : _a.find(function (site) { return site.premium; });
                    if (existingPremiumSiteUser) {
                        return [2, [
                                customerLeadTypeEnum.WixExistingPremiumSiteUserDomainPurchase,
                                NO_TRIAL_DAYS,
                                existingPremiumSiteUser,
                            ]];
                    }
                    newUserDomainData = (_b = partnerAccountData === null || partnerAccountData === void 0 ? void 0 : partnerAccountData.standardCards) === null || _b === void 0 ? void 0 : _b.find(function (project) { return project.projectId === wixDomains[0]; });
                    return [2, [
                            customerLeadTypeEnum.WixNewUserDomainsPurchase,
                            NO_TRIAL_DAYS,
                            newUserDomainData,
                        ]];
                case 5:
                    numberOfSitesOrdered = (_d = (_c = partnerOrderData === null || partnerOrderData === void 0 ? void 0 : partnerOrderData.orderConfirmationCard) === null || _c === void 0 ? void 0 : _c.siteCards) === null || _d === void 0 ? void 0 : _d.length;
                    if (numberOfSitesOrdered === 1) {
                        if (((_e = partnerOrderData === null || partnerOrderData === void 0 ? void 0 : partnerOrderData.orderConfirmationCard) === null || _e === void 0 ? void 0 : _e.siteCards[0].packageAltID) !=
                            CONNECT_DOMAINS_PKG_ALT_ID) {
                            return [2, [
                                    customerLeadTypeEnum.WixSinglePremiumWithDomainSearchVoucher,
                                    NO_TRIAL_DAYS,
                                    partnerOrderData,
                                ]];
                        }
                        return [2, [
                                customerLeadTypeEnum.WixSinglePremiumWithDomainSearchWithoutVoucher,
                                NO_TRIAL_DAYS,
                                partnerOrderData,
                            ]];
                    }
                    else if (numberOfSitesOrdered > 1) {
                        return [2, [
                                customerLeadTypeEnum.MatchingWixMultiplePremiumLead,
                                NO_TRIAL_DAYS,
                                partnerOrderData,
                            ]];
                    }
                    else {
                        return [2, null];
                    }
                case 6:
                    if (!accountGroupData) {
                        return [2, [customerLeadTypeEnum.NonMatchingLead, NO_TRIAL_DAYS, {}]];
                    }
                    if (!towerAccountGroup) {
                        return [2, [customerLeadTypeEnum.NonMatchingLead, -1, {}]];
                    }
                    towerAccount = findTowerAccount(towerAccountGroup);
                    towerSite = towerAccount.benefit.external;
                    if (towerAccount.subscription && !towerSite.firstPublishedAt) {
                        return [2, [
                                customerLeadTypeEnum.PreviousPurchaserUnpublished,
                                NO_TRIAL_DAYS,
                                towerAccount,
                            ]];
                    }
                    if (towerAccount.subscription && towerSite.firstPublishedAt) {
                        return [2, [customerLeadTypeEnum.None, NO_TRIAL_DAYS, towerAccount]];
                    }
                    if (!towerAccountGroup.isTrial) {
                        return [2, [customerLeadTypeEnum.None, NO_TRIAL_DAYS, towerAccount]];
                    }
                    if (towerSite.firstPublishedAt) {
                        return [2, [customerLeadTypeEnum.None, NO_TRIAL_DAYS, towerAccount]];
                    }
                    _g = getDaysLeft(towerSite.createdAt, Date.now()), daysLeftTrial = _g[0], daysSincePurchase = _g[1];
                    custType = getTrialType(daysLeftTrial, daysSincePurchase);
                    return [2, [custType, daysLeftTrial, towerAccount]];
                case 7: return [2];
            }
        });
    });
}

function processCustomer(order, shopperId, country, accessToken) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, towerProduct, cartTemplate, customerLeadData;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4, processOrder(order, shopperId)];
                case 1:
                    _a = _b.sent(), towerProduct = _a[0], cartTemplate = _a[1];
                    if (towerProduct === orderTypeEnum.TowerDiy ||
                        towerProduct === orderTypeEnum.TowerDify ||
                        towerProduct === orderTypeEnum.TowerDifyRecreation) {
                        return [2, [customerLeadTypeEnum.CurrentPurchaser, NO_TRIAL_DAYS, cartTemplate]];
                    }
                    return [4, getCustomerLeadData(shopperId, country)];
                case 2:
                    customerLeadData = _b.sent();
                    return [2, customerLeadData];
            }
        });
    });
}

var accountServiceLogger = getLibLogger();
var config$a = getClientConfig();
var apiConfig$a = getDefaultConfig(config$a).accountServiceApi;
var opConfig$a = apiConfig$a.operations.createFreeAccountGroup;
var accountServiceClientDispenser = new HttpClientDispenser(apiConfig$a, opConfig$a, true);
var CREATE_FREE_ACCOUNT_GROUP_PATH = '/api/v2/accountGroup/free';
function createFreeAccountGroup(parameters) {
    return __awaiter(this, void 0, void 0, function () {
        var axiosConfig, accountGroup, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    accountServiceLogger.info('createFreeAccountGroup: calling with parameters ', parameters);
                    axiosConfig = {
                        url: CREATE_FREE_ACCOUNT_GROUP_PATH,
                        method: 'POST',
                        data: parameters,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, accountServiceClientDispenser
                            .getInstance()
                            .request(axiosConfig)];
                case 2:
                    accountGroup = (_a.sent()).data;
                    accountServiceLogger.info('createFreeAccountGroup: successfully created free accountGroup', accountGroup);
                    return [2, accountGroup];
                case 3:
                    err_1 = _a.sent();
                    accountServiceLogger.error('createFreeAccountGroup: returned an error', __assign({ response: err_1.response, err: err_1 }, parameters));
                    throw err_1;
                case 4: return [2];
            }
        });
    });
}

var DEFAULT_TOWER_TRY_FIRST_PACKAGE_ALT_ID = 'bbed97ec-bed4-4aa9-9a02-9a7fe70be57f';
var CANCELED = 'CANCELED';
function getOrCreateFreeTowerAccountGroup(parameters) {
    return __awaiter(this, void 0, void 0, function () {
        var shopperId, locale, country, accountGroups, trialAccountGroup, newTrialAccountGroup;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    shopperId = parameters.shopperId, locale = parameters.locale;
                    country = locale.split('_')[1];
                    return [4, getAccountGroups(shopperId, country)];
                case 1:
                    accountGroups = (_a.sent()).accountGroups;
                    trialAccountGroup = accountGroups
                        .filter(function (accountGroup) {
                        return !accountGroup.accounts.every(function (account) { return account.status === CANCELED; });
                    })
                        .sort(function (a, b) { return b.id - a.id; })
                        .find(function (elem) {
                        return elem.packageAltId === DEFAULT_TOWER_TRY_FIRST_PACKAGE_ALT_ID;
                    });
                    if (trialAccountGroup) {
                        return [2, trialAccountGroup];
                    }
                    return [4, createFreeAccountGroup(parameters)];
                case 2:
                    newTrialAccountGroup = _a.sent();
                    return [2, newTrialAccountGroup];
            }
        });
    });
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; };
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) });

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: true });
  defineProperty(
    GeneratorFunctionPrototype,
    "constructor",
    { value: GeneratorFunction, configurable: true }
  );
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    defineProperty(this, "_invoke", { value: enqueue });
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method;
    var method = delegate.iterator[methodName];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method, or a missing .next mehtod, always terminate the
      // yield* loop.
      context.delegate = null;

      // Note: ["return"] must be used for ES3 parsing compatibility.
      if (methodName === "throw" && delegate.iterator["return"]) {
        // If the delegate iterator has a return method, give it a
        // chance to clean up.
        context.method = "return";
        context.arg = undefined$1;
        maybeInvokeDelegate(delegate, context);

        if (context.method === "throw") {
          // If maybeInvokeDelegate(context) changed context.method from
          // "return" to "throw", let that override the TypeError below.
          return ContinueSentinel;
        }
      }
      if (methodName !== "return") {
        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a '" + methodName + "' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(val) {
    var object = Object(val);
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
});

var regenerator = runtime_1;

var iterator = function (Yallist) {
  Yallist.prototype[Symbol.iterator] = function* () {
    for (let walker = this.head; walker; walker = walker.next) {
      yield walker.value;
    }
  };
};

var yallist = Yallist;

Yallist.Node = Node;
Yallist.create = Yallist;

function Yallist (list) {
  var self = this;
  if (!(self instanceof Yallist)) {
    self = new Yallist();
  }

  self.tail = null;
  self.head = null;
  self.length = 0;

  if (list && typeof list.forEach === 'function') {
    list.forEach(function (item) {
      self.push(item);
    });
  } else if (arguments.length > 0) {
    for (var i = 0, l = arguments.length; i < l; i++) {
      self.push(arguments[i]);
    }
  }

  return self
}

Yallist.prototype.removeNode = function (node) {
  if (node.list !== this) {
    throw new Error('removing node which does not belong to this list')
  }

  var next = node.next;
  var prev = node.prev;

  if (next) {
    next.prev = prev;
  }

  if (prev) {
    prev.next = next;
  }

  if (node === this.head) {
    this.head = next;
  }
  if (node === this.tail) {
    this.tail = prev;
  }

  node.list.length--;
  node.next = null;
  node.prev = null;
  node.list = null;

  return next
};

Yallist.prototype.unshiftNode = function (node) {
  if (node === this.head) {
    return
  }

  if (node.list) {
    node.list.removeNode(node);
  }

  var head = this.head;
  node.list = this;
  node.next = head;
  if (head) {
    head.prev = node;
  }

  this.head = node;
  if (!this.tail) {
    this.tail = node;
  }
  this.length++;
};

Yallist.prototype.pushNode = function (node) {
  if (node === this.tail) {
    return
  }

  if (node.list) {
    node.list.removeNode(node);
  }

  var tail = this.tail;
  node.list = this;
  node.prev = tail;
  if (tail) {
    tail.next = node;
  }

  this.tail = node;
  if (!this.head) {
    this.head = node;
  }
  this.length++;
};

Yallist.prototype.push = function () {
  for (var i = 0, l = arguments.length; i < l; i++) {
    push(this, arguments[i]);
  }
  return this.length
};

Yallist.prototype.unshift = function () {
  for (var i = 0, l = arguments.length; i < l; i++) {
    unshift(this, arguments[i]);
  }
  return this.length
};

Yallist.prototype.pop = function () {
  if (!this.tail) {
    return undefined
  }

  var res = this.tail.value;
  this.tail = this.tail.prev;
  if (this.tail) {
    this.tail.next = null;
  } else {
    this.head = null;
  }
  this.length--;
  return res
};

Yallist.prototype.shift = function () {
  if (!this.head) {
    return undefined
  }

  var res = this.head.value;
  this.head = this.head.next;
  if (this.head) {
    this.head.prev = null;
  } else {
    this.tail = null;
  }
  this.length--;
  return res
};

Yallist.prototype.forEach = function (fn, thisp) {
  thisp = thisp || this;
  for (var walker = this.head, i = 0; walker !== null; i++) {
    fn.call(thisp, walker.value, i, this);
    walker = walker.next;
  }
};

Yallist.prototype.forEachReverse = function (fn, thisp) {
  thisp = thisp || this;
  for (var walker = this.tail, i = this.length - 1; walker !== null; i--) {
    fn.call(thisp, walker.value, i, this);
    walker = walker.prev;
  }
};

Yallist.prototype.get = function (n) {
  for (var i = 0, walker = this.head; walker !== null && i < n; i++) {
    // abort out of the list early if we hit a cycle
    walker = walker.next;
  }
  if (i === n && walker !== null) {
    return walker.value
  }
};

Yallist.prototype.getReverse = function (n) {
  for (var i = 0, walker = this.tail; walker !== null && i < n; i++) {
    // abort out of the list early if we hit a cycle
    walker = walker.prev;
  }
  if (i === n && walker !== null) {
    return walker.value
  }
};

Yallist.prototype.map = function (fn, thisp) {
  thisp = thisp || this;
  var res = new Yallist();
  for (var walker = this.head; walker !== null;) {
    res.push(fn.call(thisp, walker.value, this));
    walker = walker.next;
  }
  return res
};

Yallist.prototype.mapReverse = function (fn, thisp) {
  thisp = thisp || this;
  var res = new Yallist();
  for (var walker = this.tail; walker !== null;) {
    res.push(fn.call(thisp, walker.value, this));
    walker = walker.prev;
  }
  return res
};

Yallist.prototype.reduce = function (fn, initial) {
  var acc;
  var walker = this.head;
  if (arguments.length > 1) {
    acc = initial;
  } else if (this.head) {
    walker = this.head.next;
    acc = this.head.value;
  } else {
    throw new TypeError('Reduce of empty list with no initial value')
  }

  for (var i = 0; walker !== null; i++) {
    acc = fn(acc, walker.value, i);
    walker = walker.next;
  }

  return acc
};

Yallist.prototype.reduceReverse = function (fn, initial) {
  var acc;
  var walker = this.tail;
  if (arguments.length > 1) {
    acc = initial;
  } else if (this.tail) {
    walker = this.tail.prev;
    acc = this.tail.value;
  } else {
    throw new TypeError('Reduce of empty list with no initial value')
  }

  for (var i = this.length - 1; walker !== null; i--) {
    acc = fn(acc, walker.value, i);
    walker = walker.prev;
  }

  return acc
};

Yallist.prototype.toArray = function () {
  var arr = new Array(this.length);
  for (var i = 0, walker = this.head; walker !== null; i++) {
    arr[i] = walker.value;
    walker = walker.next;
  }
  return arr
};

Yallist.prototype.toArrayReverse = function () {
  var arr = new Array(this.length);
  for (var i = 0, walker = this.tail; walker !== null; i++) {
    arr[i] = walker.value;
    walker = walker.prev;
  }
  return arr
};

Yallist.prototype.slice = function (from, to) {
  to = to || this.length;
  if (to < 0) {
    to += this.length;
  }
  from = from || 0;
  if (from < 0) {
    from += this.length;
  }
  var ret = new Yallist();
  if (to < from || to < 0) {
    return ret
  }
  if (from < 0) {
    from = 0;
  }
  if (to > this.length) {
    to = this.length;
  }
  for (var i = 0, walker = this.head; walker !== null && i < from; i++) {
    walker = walker.next;
  }
  for (; walker !== null && i < to; i++, walker = walker.next) {
    ret.push(walker.value);
  }
  return ret
};

Yallist.prototype.sliceReverse = function (from, to) {
  to = to || this.length;
  if (to < 0) {
    to += this.length;
  }
  from = from || 0;
  if (from < 0) {
    from += this.length;
  }
  var ret = new Yallist();
  if (to < from || to < 0) {
    return ret
  }
  if (from < 0) {
    from = 0;
  }
  if (to > this.length) {
    to = this.length;
  }
  for (var i = this.length, walker = this.tail; walker !== null && i > to; i--) {
    walker = walker.prev;
  }
  for (; walker !== null && i > from; i--, walker = walker.prev) {
    ret.push(walker.value);
  }
  return ret
};

Yallist.prototype.splice = function (start, deleteCount, ...nodes) {
  if (start > this.length) {
    start = this.length - 1;
  }
  if (start < 0) {
    start = this.length + start;
  }

  for (var i = 0, walker = this.head; walker !== null && i < start; i++) {
    walker = walker.next;
  }

  var ret = [];
  for (var i = 0; walker && i < deleteCount; i++) {
    ret.push(walker.value);
    walker = this.removeNode(walker);
  }
  if (walker === null) {
    walker = this.tail;
  }

  if (walker !== this.head && walker !== this.tail) {
    walker = walker.prev;
  }

  for (var i = 0; i < nodes.length; i++) {
    walker = insert(this, walker, nodes[i]);
  }
  return ret;
};

Yallist.prototype.reverse = function () {
  var head = this.head;
  var tail = this.tail;
  for (var walker = head; walker !== null; walker = walker.prev) {
    var p = walker.prev;
    walker.prev = walker.next;
    walker.next = p;
  }
  this.head = tail;
  this.tail = head;
  return this
};

function insert (self, node, value) {
  var inserted = node === self.head ?
    new Node(value, null, node, self) :
    new Node(value, node, node.next, self);

  if (inserted.next === null) {
    self.tail = inserted;
  }
  if (inserted.prev === null) {
    self.head = inserted;
  }

  self.length++;

  return inserted
}

function push (self, item) {
  self.tail = new Node(item, self.tail, null, self);
  if (!self.head) {
    self.head = self.tail;
  }
  self.length++;
}

function unshift (self, item) {
  self.head = new Node(item, null, self.head, self);
  if (!self.tail) {
    self.tail = self.head;
  }
  self.length++;
}

function Node (value, prev, next, list) {
  if (!(this instanceof Node)) {
    return new Node(value, prev, next, list)
  }

  this.list = list;
  this.value = value;

  if (prev) {
    prev.next = this;
    this.prev = prev;
  } else {
    this.prev = null;
  }

  if (next) {
    next.prev = this;
    this.next = next;
  } else {
    this.next = null;
  }
}

try {
  // add if support for Symbol.iterator is present
  iterator(Yallist);
} catch (er) {}

// A linked list to keep track of recently-used-ness


const MAX = Symbol('max');
const LENGTH = Symbol('length');
const LENGTH_CALCULATOR = Symbol('lengthCalculator');
const ALLOW_STALE = Symbol('allowStale');
const MAX_AGE = Symbol('maxAge');
const DISPOSE = Symbol('dispose');
const NO_DISPOSE_ON_SET = Symbol('noDisposeOnSet');
const LRU_LIST = Symbol('lruList');
const CACHE = Symbol('cache');
const UPDATE_AGE_ON_GET = Symbol('updateAgeOnGet');

const naiveLength = () => 1;

// lruList is a yallist where the head is the youngest
// item, and the tail is the oldest.  the list contains the Hit
// objects as the entries.
// Each Hit object has a reference to its Yallist.Node.  This
// never changes.
//
// cache is a Map (or PseudoMap) that matches the keys to
// the Yallist.Node object.
class LRUCache {
  constructor (options) {
    if (typeof options === 'number')
      options = { max: options };

    if (!options)
      options = {};

    if (options.max && (typeof options.max !== 'number' || options.max < 0))
      throw new TypeError('max must be a non-negative number')
    // Kind of weird to have a default max of Infinity, but oh well.
    this[MAX] = options.max || Infinity;

    const lc = options.length || naiveLength;
    this[LENGTH_CALCULATOR] = (typeof lc !== 'function') ? naiveLength : lc;
    this[ALLOW_STALE] = options.stale || false;
    if (options.maxAge && typeof options.maxAge !== 'number')
      throw new TypeError('maxAge must be a number')
    this[MAX_AGE] = options.maxAge || 0;
    this[DISPOSE] = options.dispose;
    this[NO_DISPOSE_ON_SET] = options.noDisposeOnSet || false;
    this[UPDATE_AGE_ON_GET] = options.updateAgeOnGet || false;
    this.reset();
  }

  // resize the cache when the max changes.
  set max (mL) {
    if (typeof mL !== 'number' || mL < 0)
      throw new TypeError('max must be a non-negative number')

    this[MAX] = mL || Infinity;
    trim(this);
  }
  get max () {
    return this[MAX]
  }

  set allowStale (allowStale) {
    this[ALLOW_STALE] = !!allowStale;
  }
  get allowStale () {
    return this[ALLOW_STALE]
  }

  set maxAge (mA) {
    if (typeof mA !== 'number')
      throw new TypeError('maxAge must be a non-negative number')

    this[MAX_AGE] = mA;
    trim(this);
  }
  get maxAge () {
    return this[MAX_AGE]
  }

  // resize the cache when the lengthCalculator changes.
  set lengthCalculator (lC) {
    if (typeof lC !== 'function')
      lC = naiveLength;

    if (lC !== this[LENGTH_CALCULATOR]) {
      this[LENGTH_CALCULATOR] = lC;
      this[LENGTH] = 0;
      this[LRU_LIST].forEach(hit => {
        hit.length = this[LENGTH_CALCULATOR](hit.value, hit.key);
        this[LENGTH] += hit.length;
      });
    }
    trim(this);
  }
  get lengthCalculator () { return this[LENGTH_CALCULATOR] }

  get length () { return this[LENGTH] }
  get itemCount () { return this[LRU_LIST].length }

  rforEach (fn, thisp) {
    thisp = thisp || this;
    for (let walker = this[LRU_LIST].tail; walker !== null;) {
      const prev = walker.prev;
      forEachStep(this, fn, walker, thisp);
      walker = prev;
    }
  }

  forEach (fn, thisp) {
    thisp = thisp || this;
    for (let walker = this[LRU_LIST].head; walker !== null;) {
      const next = walker.next;
      forEachStep(this, fn, walker, thisp);
      walker = next;
    }
  }

  keys () {
    return this[LRU_LIST].toArray().map(k => k.key)
  }

  values () {
    return this[LRU_LIST].toArray().map(k => k.value)
  }

  reset () {
    if (this[DISPOSE] &&
        this[LRU_LIST] &&
        this[LRU_LIST].length) {
      this[LRU_LIST].forEach(hit => this[DISPOSE](hit.key, hit.value));
    }

    this[CACHE] = new Map(); // hash of items by key
    this[LRU_LIST] = new yallist(); // list of items in order of use recency
    this[LENGTH] = 0; // length of items in the list
  }

  dump () {
    return this[LRU_LIST].map(hit =>
      isStale(this, hit) ? false : {
        k: hit.key,
        v: hit.value,
        e: hit.now + (hit.maxAge || 0)
      }).toArray().filter(h => h)
  }

  dumpLru () {
    return this[LRU_LIST]
  }

  set (key, value, maxAge) {
    maxAge = maxAge || this[MAX_AGE];

    if (maxAge && typeof maxAge !== 'number')
      throw new TypeError('maxAge must be a number')

    const now = maxAge ? Date.now() : 0;
    const len = this[LENGTH_CALCULATOR](value, key);

    if (this[CACHE].has(key)) {
      if (len > this[MAX]) {
        del(this, this[CACHE].get(key));
        return false
      }

      const node = this[CACHE].get(key);
      const item = node.value;

      // dispose of the old one before overwriting
      // split out into 2 ifs for better coverage tracking
      if (this[DISPOSE]) {
        if (!this[NO_DISPOSE_ON_SET])
          this[DISPOSE](key, item.value);
      }

      item.now = now;
      item.maxAge = maxAge;
      item.value = value;
      this[LENGTH] += len - item.length;
      item.length = len;
      this.get(key);
      trim(this);
      return true
    }

    const hit = new Entry(key, value, len, now, maxAge);

    // oversized objects fall out of cache automatically.
    if (hit.length > this[MAX]) {
      if (this[DISPOSE])
        this[DISPOSE](key, value);

      return false
    }

    this[LENGTH] += hit.length;
    this[LRU_LIST].unshift(hit);
    this[CACHE].set(key, this[LRU_LIST].head);
    trim(this);
    return true
  }

  has (key) {
    if (!this[CACHE].has(key)) return false
    const hit = this[CACHE].get(key).value;
    return !isStale(this, hit)
  }

  get (key) {
    return get(this, key, true)
  }

  peek (key) {
    return get(this, key, false)
  }

  pop () {
    const node = this[LRU_LIST].tail;
    if (!node)
      return null

    del(this, node);
    return node.value
  }

  del (key) {
    del(this, this[CACHE].get(key));
  }

  load (arr) {
    // reset the cache
    this.reset();

    const now = Date.now();
    // A previous serialized cache has the most recent items first
    for (let l = arr.length - 1; l >= 0; l--) {
      const hit = arr[l];
      const expiresAt = hit.e || 0;
      if (expiresAt === 0)
        // the item was created without expiration in a non aged cache
        this.set(hit.k, hit.v);
      else {
        const maxAge = expiresAt - now;
        // dont add already expired items
        if (maxAge > 0) {
          this.set(hit.k, hit.v, maxAge);
        }
      }
    }
  }

  prune () {
    this[CACHE].forEach((value, key) => get(this, key, false));
  }
}

const get = (self, key, doUse) => {
  const node = self[CACHE].get(key);
  if (node) {
    const hit = node.value;
    if (isStale(self, hit)) {
      del(self, node);
      if (!self[ALLOW_STALE])
        return undefined
    } else {
      if (doUse) {
        if (self[UPDATE_AGE_ON_GET])
          node.value.now = Date.now();
        self[LRU_LIST].unshiftNode(node);
      }
    }
    return hit.value
  }
};

const isStale = (self, hit) => {
  if (!hit || (!hit.maxAge && !self[MAX_AGE]))
    return false

  const diff = Date.now() - hit.now;
  return hit.maxAge ? diff > hit.maxAge
    : self[MAX_AGE] && (diff > self[MAX_AGE])
};

const trim = self => {
  if (self[LENGTH] > self[MAX]) {
    for (let walker = self[LRU_LIST].tail;
      self[LENGTH] > self[MAX] && walker !== null;) {
      // We know that we're about to delete this one, and also
      // what the next least recently used key will be, so just
      // go ahead and set it now.
      const prev = walker.prev;
      del(self, walker);
      walker = prev;
    }
  }
};

const del = (self, node) => {
  if (node) {
    const hit = node.value;
    if (self[DISPOSE])
      self[DISPOSE](hit.key, hit.value);

    self[LENGTH] -= hit.length;
    self[CACHE].delete(hit.key);
    self[LRU_LIST].removeNode(node);
  }
};

class Entry {
  constructor (key, value, length, now, maxAge) {
    this.key = key;
    this.value = value;
    this.length = length;
    this.now = now;
    this.maxAge = maxAge || 0;
  }
}

const forEachStep = (self, fn, node, thisp) => {
  let hit = node.value;
  if (isStale(self, hit)) {
    del(self, node);
    if (!self[ALLOW_STALE])
      hit = undefined;
  }
  if (hit)
    fn.call(thisp, hit.value, hit.key, self);
};

var lruCache = LRUCache;

var has = Object.prototype.hasOwnProperty;

function dequal(foo, bar) {
	var ctor, len;
	if (foo === bar) return true;

	if (foo && bar && (ctor=foo.constructor) === bar.constructor) {
		if (ctor === Date) return foo.getTime() === bar.getTime();
		if (ctor === RegExp) return foo.toString() === bar.toString();

		if (ctor === Array) {
			if ((len=foo.length) === bar.length) {
				while (len-- && dequal(foo[len], bar[len]));
			}
			return len === -1;
		}

		if (!ctor || typeof foo === 'object') {
			len = 0;
			for (ctor in foo) {
				if (has.call(foo, ctor) && ++len && !has.call(bar, ctor)) return false;
				if (!(ctor in bar) || !dequal(foo[ctor], bar[ctor])) return false;
			}
			return Object.keys(bar).length === len;
		}
	}

	return foo !== foo && bar !== bar;
}

var actions = {
  REQUEST_START: 'REQUEST_START',
  REQUEST_END: 'REQUEST_END'
};
var DEFAULT_OPTIONS = {
  manual: false,
  useCache: true,
  ssr: true,
  autoCancel: true
};
var useAxios = makeUseAxios();
useAxios.__ssrPromises;
    useAxios.resetConfigure;
    useAxios.configure;
    useAxios.loadCache;
    useAxios.serializeCache;
    useAxios.clearCache;

function isReactEvent(obj) {
  return obj && obj.nativeEvent && obj.nativeEvent instanceof Event;
}

function createCacheKey(config) {
  var cleanedConfig = _extends({}, config);

  delete cleanedConfig.cancelToken;
  return JSON.stringify(cleanedConfig);
}

function configToObject(config) {
  if (typeof config === 'string') {
    return {
      url: config
    };
  }

  return Object.assign({}, config);
}

function makeUseAxios(configureOptions) {
  var cache;
  var axiosInstance;
  var defaultOptions;
  var __ssrPromises = [];

  function resetConfigure() {
    cache = new lruCache();
    axiosInstance = axios;
    defaultOptions = DEFAULT_OPTIONS;
  }

  function configure(options) {
    if (options === void 0) {
      options = {};
    }

    if (options.axios !== undefined) {
      axiosInstance = options.axios;
    }

    if (options.cache !== undefined) {
      cache = options.cache;
    }

    if (options.defaultOptions !== undefined) {
      defaultOptions = _extends({}, DEFAULT_OPTIONS, options.defaultOptions);
    }
  }

  resetConfigure();
  configure(configureOptions);

  function loadCache(data) {
    cache.load(data);
  }

  function serializeCache() {
    return _serializeCache.apply(this, arguments);
  }

  function _serializeCache() {
    _serializeCache = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      var ssrPromisesCopy;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              ssrPromisesCopy = [].concat(__ssrPromises);
              __ssrPromises.length = 0;
              _context.next = 4;
              return Promise.all(ssrPromisesCopy);

            case 4:
              return _context.abrupt("return", cache.dump());

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _serializeCache.apply(this, arguments);
  }

  function clearCache() {
    cache.reset();
  }

  return Object.assign(useAxios, {
    __ssrPromises: __ssrPromises,
    resetConfigure: resetConfigure,
    configure: configure,
    loadCache: loadCache,
    serializeCache: serializeCache,
    clearCache: clearCache
  });

  function tryStoreInCache(config, response) {
    if (!cache) {
      return;
    }

    var cacheKey = createCacheKey(config);

    var responseForCache = _extends({}, response);

    delete responseForCache.config;
    delete responseForCache.request;
    cache.set(cacheKey, responseForCache);
  }

  function createInitialState(config, options) {
    var response = !options.manual && tryGetFromCache(config, options);
    return _extends({
      loading: !options.manual && !response,
      error: null
    }, response ? {
      data: response.data,
      response: response
    } : null);
  }

  function reducer(state, action) {
    var _extends2;

    switch (action.type) {
      case actions.REQUEST_START:
        return _extends({}, state, {
          loading: true,
          error: null
        });

      case actions.REQUEST_END:
        return _extends({}, state, {
          loading: false
        }, action.error ? {} : {
          data: action.payload.data
        }, (_extends2 = {}, _extends2[action.error ? 'error' : 'response'] = action.payload, _extends2));
    }
  }

  function tryGetFromCache(config, options, dispatch) {
    if (!cache || !options.useCache) {
      return;
    }

    var cacheKey = createCacheKey(config);
    var response = cache.get(cacheKey);

    if (response && dispatch) {
      dispatch({
        type: actions.REQUEST_END,
        payload: response
      });
    }

    return response;
  }

  function executeRequest(_x, _x2) {
    return _executeRequest.apply(this, arguments);
  }

  function _executeRequest() {
    _executeRequest = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(config, dispatch) {
      var response;
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              dispatch({
                type: actions.REQUEST_START
              });
              _context2.next = 4;
              return axiosInstance(config);

            case 4:
              response = _context2.sent;
              tryStoreInCache(config, response);
              dispatch({
                type: actions.REQUEST_END,
                payload: response
              });
              return _context2.abrupt("return", response);

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](0);

              if (!axios.isCancel(_context2.t0)) {
                dispatch({
                  type: actions.REQUEST_END,
                  payload: _context2.t0,
                  error: true
                });
              }

              throw _context2.t0;

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 10]]);
    }));
    return _executeRequest.apply(this, arguments);
  }

  function request(_x3, _x4, _x5) {
    return _request.apply(this, arguments);
  }

  function _request() {
    _request = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(config, options, dispatch) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", tryGetFromCache(config, options, dispatch) || executeRequest(config, dispatch));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _request.apply(this, arguments);
  }

  function useAxios(_config, _options) {
    var config = React.useMemo(function () {
      return configToObject(_config);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    useDeepCompareMemoize(_config));
    var options = React.useMemo(function () {
      return _extends({}, defaultOptions, _options);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    useDeepCompareMemoize(_options));
    var cancelSourceRef = React.useRef();

    var _React$useReducer = React.useReducer(reducer, createInitialState(config, options)),
        state = _React$useReducer[0],
        dispatch = _React$useReducer[1];

    if (typeof window === 'undefined' && options.ssr && !options.manual) {
      useAxios.__ssrPromises.push(axiosInstance(config));
    }

    var cancelOutstandingRequest = React.useCallback(function () {
      if (cancelSourceRef.current) {
        cancelSourceRef.current.cancel();
      }
    }, []);
    var withCancelToken = React.useCallback(function (config) {
      if (options.autoCancel) {
        cancelOutstandingRequest();
      }

      cancelSourceRef.current = axios.CancelToken.source();
      config.cancelToken = cancelSourceRef.current.token;
      return config;
    }, [cancelOutstandingRequest, options.autoCancel]);
    React.useEffect(function () {
      if (!options.manual) {
        request(withCancelToken(config), options, dispatch)["catch"](function () {});
      }

      return cancelOutstandingRequest;
    }, [config, options, withCancelToken, cancelOutstandingRequest]);
    var refetch = React.useCallback(function (configOverride, options) {
      configOverride = configToObject(configOverride);
      return request(withCancelToken(_extends({}, config, isReactEvent(configOverride) ? null : configOverride)), _extends({
        useCache: false
      }, options), dispatch);
    }, [config, withCancelToken]);
    return [state, refetch, cancelOutstandingRequest];
  }
}

function useDeepCompareMemoize(value) {
  var ref = React.useRef();
  var signalRef = React.useRef(0);

  if (!dequal(value, ref.current)) {
    ref.current = value;
    signalRef.current += 1;
  }

  return [signalRef.current];
}

var config$9 = getClientConfig();
var apiConfig$9 = getDefaultConfig(config$9).paidApi;
var opConfig$9 = apiConfig$9.operations.getAccountGroups;
var ddapiClientDispenser = new GraphqlClientDispenser(apiConfig$9, opConfig$9, true);
var ddapiHookDispenser = new Dispenser(function () {
    return makeUseAxios({
        axios: ddapiClientDispenser.getInstance(),
        defaultOptions: { manual: true },
    });
});
function useAccountGroups() {
    var _a = ddapiHookDispenser.getInstance()({}), responseValues = _a[0], getAccountGroups = _a[1];
    var countryCode = useLocale().countryCode;
    var _b = useIdentity(), canonicalId = _b.canonicalId, isSignedIn = _b.isSignedIn;
    useEffect(function () {
        if (isSignedIn) {
            var query = getAccountGroupsQuery(canonicalId, countryCode);
            var axiosConfig = {
                url: '/api/v1',
                data: query,
            };
            getAccountGroups(axiosConfig);
        }
    }, [countryCode, getAccountGroups, isSignedIn, canonicalId]);
    return responseValues;
}

var config$8 = getClientConfig();
var apiConfig$8 = getDefaultConfig(config$8).subscriptionsServiceApi;
var opConfig$8 = apiConfig$8.operations.getCurrentPlanInfo;
var subscriptionApiClientDispenser$3 = new HttpClientDispenser(apiConfig$8, opConfig$8, true);
function getSubscriptionGroupData(subscriptionGroupAltId) {
    return __awaiter(this, void 0, void 0, function () {
        var axiosConfig, data, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    invariant(subscriptionGroupAltId, 'Required parameter is missing: subscriptionGroupAltId');
                    axiosConfig = {
                        url: "/api/v2/subscriptionGroup/".concat(subscriptionGroupAltId),
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, subscriptionApiClientDispenser$3
                            .getInstance()
                            .request(axiosConfig)];
                case 2:
                    data = _a.sent();
                    return [2, data.data];
                case 3:
                    e_1 = _a.sent();
                    getLibLogger().error('getSubscriptionInfos: Request to get partnerAccountGroups failed', { subscriptionGroupAltId: subscriptionGroupAltId, e: e_1 });
                    return [2, null];
                case 4: return [2];
            }
        });
    });
}

function getSubscriptionData(subscriptionGroupAltId) {
    return __awaiter(this, void 0, void 0, function () {
        var currentPlanData, subscriptionGroupData, latestSubscription;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    invariant(subscriptionGroupAltId, 'Required parameter is missing: subscriptionGroupAltId');
                    currentPlanData = {
                        currentPlan: '',
                        nextBillDate: '',
                        diffDate: 0,
                    };
                    return [4, getSubscriptionGroupData(subscriptionGroupAltId)];
                case 1:
                    subscriptionGroupData = _a.sent();
                    if (!subscriptionGroupData ||
                        subscriptionGroupData.subscriptionGroupStatus !== 'ACTIVE') {
                        return [2, null];
                    }
                    currentPlanData.nextBillDate = subscriptionGroupData.nextBillDate;
                    currentPlanData.diffDate = differenceInDays(new Date().getTime(), new Date(subscriptionGroupData.creationDate).getTime());
                    latestSubscription = subscriptionGroupData === null || subscriptionGroupData === void 0 ? void 0 : subscriptionGroupData.subscriptions.find(function (subscription) { return subscription.subscriptionStatus === 'ACTIVE'; });
                    if (!latestSubscription) {
                        return [2, null];
                    }
                    currentPlanData.currentPlan =
                        latestSubscription.productAttributes.packageLevel ||
                            latestSubscription.productAttributes['Package Level'];
                    return [2, currentPlanData];
            }
        });
    });
}

var config$7 = getClientConfig();
var apiConfig$7 = getDefaultConfig(config$7).partnerServiceApi;
var opConfig$7 = apiConfig$7.operations.getPartnerStandardCardAccount;
var partnerApiClientDispenser$2 = new HttpClientDispenser(apiConfig$7, opConfig$7, true);
var partnerHookDispenser$2 = new Dispenser(function () {
    return makeUseAxios({
        axios: partnerApiClientDispenser$2.getInstance(),
        defaultOptions: { manual: true },
    });
});
function usePartnerAccountGroups() {
    var _a = partnerHookDispenser$2.getInstance()({}), responseValues = _a[0], getPartnerStandardCardAccount = _a[1];
    var _b = useIdentity(), shopperId = _b.canonicalId, isSignedIn = _b.isSignedIn;
    var locale = useLocale().identifier;
    useEffect(function () {
        if (isSignedIn) {
            var axiosConfig = {
                url: "api/v1/project/card/workspace/WIX/".concat(shopperId, "/").concat(locale),
            };
            getPartnerStandardCardAccount(axiosConfig);
        }
    }, [getPartnerStandardCardAccount, isSignedIn, shopperId, locale]);
    return responseValues;
}

var config$6 = getClientConfig();
var apiConfig$6 = getDefaultConfig(config$6).partnerServiceApi;
var opConfig$6 = apiConfig$6.operations.getPartnerDomainSearchData;
var partnerApiClientDispenser$1 = new HttpClientDispenser(apiConfig$6, opConfig$6);
var partnerHookDispenser$1 = new Dispenser(function () {
    return makeUseAxios({
        axios: partnerApiClientDispenser$1.getInstance(),
        defaultOptions: { manual: true },
    });
});
function usePartnerDomainSearch(domainName, locale, source, requestor) {
    invariant(domainName, 'Required parameter is missing: domainName');
    invariant(locale, 'Required parameter is missing: locale');
    var _a = partnerHookDispenser$1.getInstance()({}), responseValues = _a[0], getPartnerDomainSearchData = _a[1];
    useEffect(function () {
        var axiosConfig = {
            url: "/api/anonymous/v1/domain/search",
            method: 'POST',
            data: { domain: domainName, source: source, requestor: requestor },
            params: { locale: locale },
        };
        getPartnerDomainSearchData(axiosConfig);
    }, [domainName, getPartnerDomainSearchData]);
    return responseValues;
}

var config$5 = getClientConfig();
var apiConfig$5 = getDefaultConfig(config$5).partnerServiceApi;
var opConfig$5 = apiConfig$5.operations.getPartnerStandardCardAccount;
var partnerApiClientDispenser = new HttpClientDispenser(apiConfig$5, opConfig$5, true);
var partnerHookDispenser = new Dispenser(function () {
    return makeUseAxios({
        axios: partnerApiClientDispenser.getInstance(),
        defaultOptions: { manual: true },
    });
});
function usePartnerAccountProducts() {
    var _a = partnerHookDispenser.getInstance()({}), responseValues = _a[0], getPartnerAccountProducts = _a[1];
    var _b = useIdentity(), shopperId = _b.canonicalId, isSignedIn = _b.isSignedIn;
    useEffect(function () {
        if (isSignedIn) {
            var axiosConfig = {
                url: "api/v1/products/".concat(shopperId),
            };
            getPartnerAccountProducts(axiosConfig);
        }
    }, [getPartnerAccountProducts, isSignedIn, shopperId]);
    return responseValues;
}

function getPartnerAccountData(shopperId) {
    return __awaiter(this, void 0, void 0, function () {
        var accessToken, pathAndQueryString, PARTNER_ORIGIN, partnerAccountData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    invariant(shopperId, 'Required parameter is missing: shopperId');
                    accessToken = getIdentity().accessToken;
                    pathAndQueryString = "api/v1/account/WIX/".concat(shopperId);
                    PARTNER_ORIGIN = getPartnerIntegrationOrigin();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, axios.get("".concat(PARTNER_ORIGIN, "/").concat(pathAndQueryString), {
                            headers: {
                                'Content-Type': 'application/json',
                                authorization: "Bearer ".concat(accessToken),
                            },
                        })];
                case 2:
                    partnerAccountData = (_a.sent()).data;
                    return [2, partnerAccountData];
                case 3:
                    _a.sent();
                    getLibLogger().warn('getPartnerAccountData: Request to get getPartnerAccountData failed', { shopperId: shopperId });
                    return [2, null];
                case 4: return [2];
            }
        });
    });
}

var logger$1 = getLibLogger();
var config$4 = getClientConfig();
var apiConfig$4 = getDefaultConfig(config$4).partnerServiceApi;
var opConfig$4 = apiConfig$4.operations.getPartnerAccountDomainSearchData;
var partnerServiceApiClientDispenser$1 = new HttpClientDispenser(apiConfig$4, opConfig$4, true);
function getPartnerAccountDomainSearch(domainName, shopperId, locale, source, requestor) {
    var _a, _b;
    if (requestor === void 0) { requestor = 'Digital'; }
    return __awaiter(this, void 0, void 0, function () {
        var axiosConfig, data, error_1, partnerAccountDomainSearchData;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    invariant(domainName, 'Required parameter is missing: domainName');
                    invariant(shopperId, 'Required parameter is missing: shopperId');
                    invariant(locale, 'Required parameter is missing: locale');
                    source = source || '';
                    axiosConfig = {
                        url: "/api/v1/domain/search/WIX/".concat(shopperId),
                        method: 'POST',
                        data: { domain: domainName },
                        params: { locale: locale, source: source, requestor: requestor },
                    };
                    logger$1.info('getPartnerAccountDomainSearch: calling with parameters ', {
                        domain: domainName,
                        locale: locale,
                        shopperId: shopperId,
                    });
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4, partnerServiceApiClientDispenser$1
                            .getInstance()
                            .request(axiosConfig)];
                case 2:
                    data = (_c.sent()).data;
                    return [2, data];
                case 3:
                    error_1 = _c.sent();
                    logger$1.warn('getPartnerAccountDomainSearch: Request to get PartnerAccountDomainSearchResponse failed', { domain: domainName, error: error_1 });
                    partnerAccountDomainSearchData = (_b = (_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : {
                        domain: domainName,
                        available: false,
                        suggestions: [],
                        errorResponse: {
                            message: null,
                            details: null,
                        },
                    };
                    return [2, partnerAccountDomainSearchData];
                case 4: return [2];
            }
        });
    });
}

var logger = getLibLogger();
function getPartnerDomainSearch(domainName, locale, source, requestor) {
    var _a, _b;
    if (requestor === void 0) { requestor = 'Digital'; }
    return __awaiter(this, void 0, void 0, function () {
        var PARTNER_ORIGIN, data, error_1, partnerAccountDomainSearchData;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    invariant(domainName, 'Required parameter is missing: domainName');
                    invariant(locale, 'Required parameter is missing: locale');
                    logger.info('getPartnerDomainSearch: calling with parameters ', {
                        domain: domainName,
                        locale: locale,
                    });
                    PARTNER_ORIGIN = getPartnerIntegrationOrigin();
                    source = source || '';
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4, axios.post("".concat(PARTNER_ORIGIN, "/api/anonymous/v1/domain/search"), {
                            domain: domainName,
                        }, {
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            params: { locale: locale, source: source, requestor: requestor },
                        })];
                case 2:
                    data = (_c.sent()).data;
                    return [2, data];
                case 3:
                    error_1 = _c.sent();
                    logger.error('getPartnerDomainSearch: Request to get PartnerDomainSearchResponse failed', { domain: domainName, error: error_1 });
                    partnerAccountDomainSearchData = (_b = (_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : {
                        domain: domainName,
                        available: false,
                        suggestions: [],
                        errorResponse: {
                            message: null,
                            details: null,
                        },
                    };
                    return [2, partnerAccountDomainSearchData];
                case 4: return [2];
            }
        });
    });
}

var loggerService = getLibLogger();
var config$3 = getClientConfig();
var DOMAIN_REGISTRATION_PATH = '/api/v1/domain/register/WIX/';
var apiConfig$3 = getDefaultConfig(config$3).partnerServiceApi;
var opConfig$3 = apiConfig$3.operations.getPartnerDomainRegistrantId;
var partnerServiceApiClientDispenser = new HttpClientDispenser(apiConfig$3, opConfig$3, true);
function getPartnerDomainRegistrantId(cannonicalID, locale, siteId, data) {
    return __awaiter(this, void 0, void 0, function () {
        var axiosConfig, partnerDomainRegistrantId, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    invariant(cannonicalID, 'Required parameter is missing: cannonicalID');
                    invariant(locale, 'Required parameter is missing: locale');
                    invariant(data, 'Required parameter is missing: data');
                    loggerService.info('getPartnerDomainRegistrantId: calling with parameters ', data);
                    axiosConfig = {
                        url: "".concat(DOMAIN_REGISTRATION_PATH).concat(cannonicalID),
                        method: 'POST',
                        data: data,
                        params: { locale: locale, siteId: siteId },
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, partnerServiceApiClientDispenser
                            .getInstance()
                            .request(axiosConfig)];
                case 2:
                    partnerDomainRegistrantId = (_a.sent()).data;
                    return [2, partnerDomainRegistrantId];
                case 3:
                    err_1 = _a.sent();
                    loggerService.warn('getPartnerDomainRegistrantId: Request to get partnerAccountDomainRegistrationResponse failed', { cannonicalID: cannonicalID, err: err_1 });
                    return [2, null];
                case 4: return [2];
            }
        });
    });
}

var config$2 = getClientConfig();
var apiConfig$2 = getDefaultConfig(config$2).subscriptionsServiceApi;
var opConfig$2 = apiConfig$2.operations.getCurrentPlanInfo;
var subscriptionApiClientDispenser$2 = new HttpClientDispenser(apiConfig$2, opConfig$2, true);
function getUnconsumedAmountSubscriptionData(subscriptionGroupAltId) {
    return __awaiter(this, void 0, void 0, function () {
        var axiosConfig, data, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    invariant(subscriptionGroupAltId, 'Required parameter is missing: subscriptionGroupAltId');
                    axiosConfig = {
                        url: "/api/v2/subscriptionGroup/".concat(subscriptionGroupAltId, "/unconsumed"),
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, subscriptionApiClientDispenser$2
                            .getInstance()
                            .request(axiosConfig)];
                case 2:
                    data = _a.sent();
                    return [2, data.data];
                case 3:
                    e_1 = _a.sent();
                    getLibLogger().error('getUnconsumedAmountSubscriptionData: Request to get partnerAccountGroups failed', { subscriptionGroupAltId: subscriptionGroupAltId, e: e_1 });
                    return [2, null];
                case 4: return [2];
            }
        });
    });
}

var config$1 = getClientConfig();
var apiConfig$1 = getDefaultConfig(config$1).subscriptionsServiceApi;
var opConfig$1 = apiConfig$1.operations.scheduledChange;
var subscriptionApiClientDispenser$1 = new HttpClientDispenser(apiConfig$1, opConfig$1, true);
function scheduleSubscriptionChange(changeType, billingInterval, intervalFrequency, subscriptions, subscriptionGroupAltId) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var requestBody, axiosConfig, response, e_1, errorDetails;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    invariant(changeType, 'Required parameter is missing: changeType');
                    invariant(billingInterval, 'Required parameter is missing: billingInterval');
                    invariant(intervalFrequency, 'Required parameter is missing: intervalFrequency');
                    invariant(subscriptions, 'Required parameter is missing: subscriptions');
                    invariant(subscriptionGroupAltId, 'Required parameter is missing: subscriptionGroupAltId');
                    requestBody = {
                        changeType: changeType,
                        executionData: {
                            billingInterval: billingInterval,
                            intervalFrequency: intervalFrequency,
                            subscriptions: subscriptions,
                        },
                        subscriptionGroupAltId: subscriptionGroupAltId,
                    };
                    axiosConfig = {
                        method: 'POST',
                        url: '/api/v2/scheduledChange',
                        data: requestBody,
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4, subscriptionApiClientDispenser$1
                            .getInstance()
                            .request(axiosConfig)];
                case 2:
                    response = _b.sent();
                    return [2, response.data];
                case 3:
                    e_1 = _b.sent();
                    errorDetails = {
                        changeType: changeType,
                        billingInterval: billingInterval,
                        intervalFrequency: intervalFrequency,
                        subscriptions: subscriptions,
                        subscriptionGroupAltId: subscriptionGroupAltId,
                        error: e_1.message,
                        stack: e_1.stack,
                        response: ((_a = e_1.response) === null || _a === void 0 ? void 0 : _a.data) || null,
                    };
                    getLibLogger().error('scheduleSubscriptionChange: Request to schedule subscription change failed', errorDetails);
                    return [2, null];
                case 4: return [2];
            }
        });
    });
}

var config = getClientConfig();
var apiConfig = getDefaultConfig(config).subscriptionsServiceApi;
var opConfig = apiConfig.operations.getCurrentPlanInfo;
var subscriptionApiClientDispenser = new HttpClientDispenser(apiConfig, opConfig, true);
function getSubscriptionGroupByShopperId(shopperId) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var axiosConfig, response, e_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    invariant(shopperId, 'Required parameter is missing: shopperId');
                    axiosConfig = {
                        url: "/api/v2/subscriptionGroup",
                        method: 'GET',
                        params: { customerId: shopperId },
                    };
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4, subscriptionApiClientDispenser
                            .getInstance()
                            .request(axiosConfig)];
                case 2:
                    response = _c.sent();
                    return [2, (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.content) !== null && _b !== void 0 ? _b : null];
                case 3:
                    e_1 = _c.sent();
                    getLibLogger().error('getSubscriptionGroupByShopperId: Failed to fetch subscription groups by shopperId', { shopperId: shopperId, e: e_1 });
                    return [2, null];
                case 4: return [2];
            }
        });
    });
}

export { DEFAULT_TOWER_TRY_FIRST_PACKAGE_ALT_ID, customerLeadTypeEnum, getCustomerLeadData, getOrCreateFreeTowerAccountGroup, getPartnerAccountData, getPartnerAccountDomainSearch, getPartnerAccountGroup, getPartnerAccountProducts, getPartnerDomainRegistrantId, getPartnerDomainSearch, getPartnerOrderDataWithSiteId, getSubscriptionData, getSubscriptionGroupByShopperId, getSubscriptionGroupData, getUnconsumedAmountSubscriptionData, processCustomer, scheduleSubscriptionChange, useAccountGroups, usePartnerAccountGroups, usePartnerAccountProducts, usePartnerDomainSearch };
